import request from '../utils/request'

/**
 * 获取question info
 * @param data
 * @see /src/store/modules/ide.js :: getQceitQuery
 * @returns {Promise<void>}
 */
const questionInfo = async (data) => {
  const res = await request.httpGet('/qceit/question/info', {ID: data.questionId, ...data})
  return res
}

export default {
  questionInfo,
}
